export const masters = {
  mastersGreen: '#0b3d2e',
  augustaGreen: '#13533f',
  fairway: '#1a6a4d',
  pineShadow: '#082a20',
  ivory: '#f5f0e1',
  ivoryMuted: 'rgba(245, 240, 225, 0.72)',
  ivoryDim: 'rgba(245, 240, 225, 0.45)',
  ivoryLine: 'rgba(245, 240, 225, 0.12)',
  ivoryStripe: 'rgba(245, 240, 225, 0.04)',
  champion: '#c9a961',
  championBright: '#e4c275',
  silver: '#c8cdd2',
  bronze: '#b87333',
  pimento: '#a8231a',
  pimentoSoft: '#d94a3f',
};

export const mastersFonts = {
  display: "'Playfair Display', 'Times New Roman', Georgia, serif",
  body: "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  numeric: "'Public Sans', -apple-system, sans-serif",
};

export const tabularNums = {
  fontVariantNumeric: 'tabular-nums' as const,
  fontFeatureSettings: '"tnum"',
};
